'use strict';

(function (snapOnline, $) {;
    // Ensure required nested namespaces are declared.
    snapOnline.FmsAjax = snapOnline.FmsAjax || {};

    
    // ----- Public interface from here -----
    snapOnline.FmsAjax.ajaxCall = function (dataOb, actionurl, success, fail) {
        if (!dataOb) {
            if (typeof fail == 'function') {
                fail("error contacting server");
            }
            return;
        }
        dataOb.append('__RequestVerificationToken', snapOnline.getRequestVerificationToken());

        // Submit request to the server.
        var ajaxOptions = {
            method: 'POST',
            headers: { 'snapJsonHeader': 'json' },
            data: dataOb,
            url: actionurl,
            processData: false,
            contentType: false, //makes no sense... but its what _they_ say to do (and it does make it work)
        };

        jQuery.ajax(ajaxOptions).done(success)
            .fail(function (xhr, textStatus) {
                if (xhr.status === 401) {
                    if (typeof fail == 'function') {
                        fail("access denied");
                    }
                    document.location.href = snapOnline.getActionUrl('Account', 'Login');
                } else if (xhr.status === 405) {
                    if (typeof fail == 'function') {
                        fail("Insuficent permission");
                    }
                } else {
                    if (typeof fail == 'function') {
                        fail("error contacting server");
                    }
                }
            });
    };

    snapOnline.FmsAjax.GenericAjax = function (url, dataOb, urlViewOnSuccess) {
        var fail = function (message) { snapOnline.Dialogs.showErrorMessage(message, true); };
        var success = function (serverResponse) {
            serverResponse = serverResponse || {};
            if (!serverResponse.success && serverResponse.message!==null && serverResponse.message !== "") {
                snapOnline.Dialogs.showErrorMessage(serverResponse.message, true);
            } else {
                snapOnline.replaceElementWithAjaxGet('MainPanel', urlViewOnSuccess);
            }
        };
        snapOnline.FmsAjax.ajaxCall(dataOb, url, success, fail);
    };

}(window.SnapOnline = window.SnapOnline || {}, jQuery));